import React from "react";
import { RCCButton, RCCGrid, RCCIcon, RCCInput, RCCSwitch, RCCTextArea, RCCTooltip } from "react-common-components";
import Select from "src/components/Select";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { bindTypes, IBindsTab,  IWdtba009, IWdtba010 } from "../../interface";
import { FieldOnRight,StyledFieldset } from "../../styles";

const TabBinds: React.FC<IBindsTab> = ({ 
	binds,
	setBinds,
	register,
	control,
	errors,
	setValue,
	unregister,
	getValues
}) => {
	const { translate} = useTranslation();

	const append = (bindIndex:number) => {
		const formValues = getValues(`binds[${bindIndex}].options`) as IWdtba010[];
		let newOptions = binds[bindIndex]?.options?.map((x) => {
			const rule = formValues.find((y) => y.id === x.id); 
			if(rule){
				return {...x,...rule};
			}
			return x;
			
		});
		if(!newOptions)
			newOptions=[] as IWdtba010[];

		newOptions?.push(
			{
				id:v4(),
				wda010Id:0,
				wda010Valor:"",
				wda010Descricao:""
			} as IWdtba010
		);
		
		setValue(`binds.${bindIndex}.options`,newOptions);
		setBinds((prevState) => 
			prevState.map((bind,index) => {
				if(bindIndex!==index)
					return bind;
				return {...bind,options:newOptions};
			})
		);
	};

	const remove = (id: string,bindIndex: number) => {
		const formValues = getValues(`binds[${bindIndex}].options`) as IWdtba010[];
		const newOptions = binds[bindIndex]?.options?.map((x) => {
			const rule = formValues.find((y) => y.id === x.id); 
			if(rule){
				return {...x,...rule};
			}
			return x;
			
		}).filter((x) => x.id!==id);

		unregister(`binds.${bindIndex}.options`);
		setBinds((prevState) => 
			prevState.map((bind,index) => {
				if(bindIndex!==index)
					return bind;
				return {...bind,options:newOptions};
			})
		);
	};

	return(
		<RCCGrid container item 
			justifyContent="center">
			{binds.map((bind:IWdtba009,bindIndex) => (<RCCGrid container item 
				xs={12} 
				lg={10} 
				key={v4()}
			>
				
				<StyledFieldset>
					<legend>
						<Title size="sm" color="defaultColor">{bind.wda009Bind}</Title>
					</legend>
					<RCCGrid container item>
						<input 
							{...register(`binds[${bindIndex}].wda009Id`)} 
							name={`binds[${bindIndex}].wda009Id`}
							value={bind.wda009Id}
							type="hidden"
						/>	
						<input 
							{...register(`binds[${bindIndex}].id`)} 
							name={`binds[${bindIndex}].id`}
							value={bind.id}
							type="hidden"
						/>	
						<input 
							{...register(`binds[${bindIndex}].wda009Bind`)} 
							name={`binds[${bindIndex}].wda009Bind`}
							value={bind.wda009Bind}
							type="hidden"
						/>
						<RCCGrid container item 
							md={3}
							sm={6}
							xs={12}
							styleInline={FieldOnRight}
						>
							<RCCInput
								name={`binds[${bindIndex}].wda009Label`}
								label={translate("Label")}
								register={register}
								defaultValue={bind.wda009Label}
								error = {errors.binds && errors?.binds[bindIndex]?.wda009Label}
								required
								maxLength={40}
							/>
						</RCCGrid>
						<RCCGrid container item 
							md={3}
							sm={6}
							xs={12}
							styleInline={FieldOnRight}
						>
							<RCCInput
								name={`binds[${bindIndex}].wda009Valordefault`}
								label={translate("Valor padrão")}
								register={register}
								defaultValue={bind.wda009Valordefault}
								error = {errors.binds && errors?.binds[bindIndex]?.wda009Valordefault}
								maxLength={120}
							/>
						</RCCGrid>
						<RCCGrid container item 
							md={3}
							sm={6}
							xs={12}
							styleInline={FieldOnRight}
						>
							<Select
								control={control}
								name={`binds[${bindIndex}].wda009Tipo`}
								label={translate("Tipo")}
								required
								defaultValue={bind.wda009Tipo?.toString()||bindTypes.FREE}
								error = {errors.binds && errors?.binds[bindIndex]?.wda009Tipo}
								onChangeCapture={(e) => {
									setBinds((prevState) => prevState.map((x) => {
										if(x.id===bind.id)
											return {...x,wda009Tipo:e.value as bindTypes};
										return x;
									}));
								}}
								options={[
									{value:bindTypes.FREE,label:translate("Valor livre")},
									{value:bindTypes.DATE,label:translate("Data")},
									{value:bindTypes.PERIOD,label:translate("Período")},
									{value:bindTypes.OPTIONS_LIST,label:translate("Lista de opções")},
									{value:bindTypes.lOV,label:translate("Lista de valores")}
								]}
							/>
						</RCCGrid>
						<RCCGrid container item 
							md={2}
							sm={6}
							xs={4}
							styleInline={FieldOnRight}
						>
							<RCCGrid container item 
								styleInline={`&.MuiGrid-root {
									padding-left: 0.5rem;
									@media(max-width: 600px){
										padding-left: 8px;
									}
									padding-top:10px;
								}`} 
								wrap="nowrap" 
								alignItems="center"
							>
								<RCCSwitch
									name={`binds[${bindIndex}].wda009Obrigatorio`}
									label={translate("Obrigatório")}
									register={register}
									error = {errors.binds && errors?.binds[bindIndex]?.wda009Obrigatorio}
									defaultChecked={bind.wda009Obrigatorio}
								/>	
								{bind.wda009Tipo?.toString() === bindTypes.OPTIONS_LIST &&
									<RCCGrid container item 
										sm={3}
										xs={4}
										styleInline={FieldOnRight}
										wrap="nowrap"
									>
										<RCCTooltip
											text={translate("Adicionar opção")}
											color="purple"
											position="left"
										>
											<RCCButton
												icon={{name: "plus"}}
												color="purple"
												onClick={() => {
													append(bindIndex);
												}}
												layout="isRounded"
												size="sm"
											/>	
										</RCCTooltip>
										<RCCTooltip
											text={translate("Visualizar opções")}
											color={bind.showOptions ? "blue" :"grey"}
											position="left"
										>
											<RCCButton
												icon={{name: bind.showOptions ? "eye" : "eyeSlash"}}
												color={bind.showOptions ? "blue" :"grey"}
												onClick={() => {
													setBinds((prevState) => prevState.map((x) => {
														if(x.id===bind.id)
															return {...x,showOptions:!bind.showOptions};
														return x;
													}));
												}}
												layout="isRounded"
												size="sm"
											/>	
										</RCCTooltip>
									</RCCGrid>
								}
							</RCCGrid>
						</RCCGrid>
						{bind.wda009Tipo?.toString() === bindTypes.lOV &&
							<RCCGrid container item xs={12}>
								<RCCTextArea 
									name={`binds[${bindIndex}].wda009Sqllov`}
									label={translate("Sql")}
									required
									defaultValue={bind.wda009Sqllov}
									error={errors.binds && errors?.binds[bindIndex]?.wda009Sqllov}
									register={register}
									rows={4}
								/>
							</RCCGrid>
						}
						{bind.wda009Tipo?.toString() === bindTypes.OPTIONS_LIST &&
							<RCCGrid container item xs={12} styleInline={`&.MuiGrid-root {display:${bind.showOptions?"block":"none"};}`}>
								<RCCGrid container justifyContent="space-between" alignContent="flex-end" wrap="nowrap">
									{errors?.binds?.length > 0 && errors?.binds[bindIndex]?.options &&
										<RCCGrid container item alignItems="center">	
											<RCCIcon name="errorOutline" size={19} color="var(--red)"/>
											<Title color="red" size="sm">{errors?.binds[bindIndex]?.options?.message}</Title>
										</RCCGrid>
									}
								</RCCGrid>
								<RCCGrid container item>
									{bind.options?.map((option,index) => (
										<RCCGrid container item key={v4()}>
											<RCCGrid container item 
												sm={4}
												xs={12}
												styleInline={FieldOnRight}
											>
												<RCCInput
													name={`binds[${bindIndex}].options[${index}].wda010Descricao`}
													label={translate("Descrição")}
													register={register}
													defaultValue={option.wda010Descricao}
													error = {errors?.binds?.length > 0 && errors?.binds[bindIndex]?.options && errors?.binds[bindIndex]?.options[index]?.wda010Descricao}
													required
													maxLength={40}
												/>
												<input 
													{...register(`binds[${bindIndex}].options[${index}].id`)} 
													name={`binds[${bindIndex}].options[${index}].id`}
													value={option.id}
													type="hidden"
												/>
												<input 
													{...register(`binds[${bindIndex}].options[${index}].wda010Id`)} 
													name={`binds[${bindIndex}].options[${index}].wda010Id`}
													value={option.wda010Id}
													type="hidden"
												/>
												<input 
													{...register(`binds[${bindIndex}].options[${index}].wda010Opcao`)} 
													name={`binds[${bindIndex}].options[${index}].wda010Opcao`}
													value={option.wda010Opcao}
													type="hidden"
												/>
											</RCCGrid>
											<RCCGrid container item 
												sm={4}
												xs={9}
												styleInline={FieldOnRight}
											>
												<RCCInput
													name={`binds[${bindIndex}].options[${index}].wda010Valor`}
													label={translate("Valor")}
													register={register}
													defaultValue={option.wda010Valor}
													error = {errors?.binds?.length > 0 && errors?.binds[bindIndex]?.options && errors?.binds[bindIndex]?.options[index]?.wda010Valor}
													required
													maxLength={40}
												/>
								
											</RCCGrid>
											<RCCGrid container item 
												sm={4}
												xs={3}
												styleInline={FieldOnRight}
												alignContent="center"
												justifyContent="flex-end"
											>
												<RCCTooltip
													text={translate("Excluir opção")}
													color="red"
													position="left">
													<RCCButton
														icon={{name: "trash"}}
														color="red"
														onClick={() => {
															remove(option.id,bindIndex);
														}}
														layout="isRounded"
														size="sm"
													/>	
												</RCCTooltip>
											</RCCGrid>
										</RCCGrid>
									))}
								</RCCGrid>
					
							</RCCGrid>
						}
					</RCCGrid> 
				</StyledFieldset>
			</RCCGrid>
			))}	
		</RCCGrid>
	);
};
export default TabBinds;
